import { render, staticRenderFns } from "./EnrollmentCreateDialog.vue?vue&type=template&id=6eb6574a&"
import script from "./EnrollmentCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentCreateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports